import React from 'react';
import { Mail } from 'lucide-react';
import { Badge } from 'src/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'src/components/ui/tooltip';
import { cn } from 'src/lib/utils';

type UnreadMessagesBadgeProps = {
  /** Whether to show the badge */
  show: boolean;
  /** Custom positioning classes for the badge */
  position?: string;
  /** Additional responsive classes */
  responsive?: string;
  /** Tooltip text content */
  tooltipText: string;
  /** Whether to wrap with TooltipProvider (use false if parent already provides it) */
  withProvider?: boolean;
  /** Additional className for the badge */
  className?: string;
  /** Whether to use absolute positioning */
  absolute?: boolean;
};

const UnreadMessagesBadge: React.FC<UnreadMessagesBadgeProps> = ({
  show,
  position = 'tw-left-0 tw-top-0',
  responsive = '',
  tooltipText,
  withProvider = true,
  className,
  absolute = true,
}) => {
  if (!show) return null;

  const badgeContent = (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge
          className={cn(
            'tw-h-6 tw-w-6 tw-justify-center tw-rounded-full tw-border-0 tw-bg-orange tw-p-0 tw-font-medium hover:tw-bg-orange',
            absolute ? 'tw-absolute' : '',
            position,
            responsive,
            className,
          )}
        >
          <Mail size={12} className="tw-text-white" />
        </Badge>
      </TooltipTrigger>
      <TooltipContent>{tooltipText}</TooltipContent>
    </Tooltip>
  );

  if (withProvider) {
    return <TooltipProvider>{badgeContent}</TooltipProvider>;
  }

  return badgeContent;
};

export { UnreadMessagesBadge };
export type { UnreadMessagesBadgeProps };
